// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__dRTYn","label":"Section_label__3DiHD","contentWrap":"Section_contentWrap__eQw7E","footer":"Section_footer__vpxAv","footerInner":"Section_footerInner__2FgRd"};